import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const DatadogAiAccesses = {
  permission: Access({
    description:
      "Scopes in a Datadog organization, granted via a shared NHI credential",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      organization: {
        type: "dynamic",
        label: "Organization",
        description: "Datadog organization",
      },
      // Values are Datadog permission names (e.g. "logs_read_data"), limited to
      // what the service account's roles grant.
      policies: {
        type: "dynamic",
        label: "Scopes",
        description: "Authorization scopes to grant in the organization",
        multivalued: true,
      },
    },
    render: {
      locator: "organization",
      policy: "policies",
    } as const,
  }),
};

export type DatadogAiAccesses = typeof DatadogAiAccesses;
export type DatadogAiAccess = DatadogAiAccesses[keyof DatadogAiAccesses];
export type DatadogAiPermissionAccess = DatadogAiAccesses["permission"];
